import { useMutation } from "@tanstack/react-query";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import type { IAgreeSecurityPledgeResponse } from "../models/securityPledge";

export function useAgreeSecurityPledge() {
	const { mutateAsync: agreeSecurityPledge, isPending } = useMutation({
		mutationFn: async (version: string) => {
			const response = await HttpClient.request<IAgreeSecurityPledgeResponse>(
				OnSiteApi.agreeSecurityPledge(version),
			);
			return response.data;
		},
		gcTime: 0,
	});
	return { agreeSecurityPledge, isPending };
}
